import { useIntl } from 'react-intl';

export default function useFinancePackageFrequencyLabelProvider(): (
  packageCode: string,
  variant: 'short' | 'long',
) => string {
  const intl = useIntl();

  return (packageCode: string, variant: 'short' | 'long') =>
    intl.formatMessage({ id: `common.finance.packages.${packageCode}.frequencyLabel.${variant}` });
}
